import { api } from '../api-client.config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { PuzzleItem } from '../types';

const updatePuzzleItem = (puzzleItem: PuzzleItem) =>
  api.put(`/puzzle-item/${puzzleItem.id}`, puzzleItem);

export const useUpdatePuzzleItemMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['update-puzzle-item'],
    mutationFn: updatePuzzleItem,
    onSuccess: () => {
      toast.success('Puzzle item updated successfully');

      queryClient.invalidateQueries({
        queryKey: ['puzzle-items'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
